export const conditionalOperator = x => y => z => (x ? y : z);

export const logicalAndOperator = x => y => x && y;

export const logicalOrOperator = x => y => x || y;

export const logicalNotOperator = x => !x;

export const plusOperator = x => y => x + y;

export const equalsOperator = x => y => x === y;
